import _regeneratorRuntime from "/codebuild/output/src386676321/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _this = this;

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import axios from '../internal/axios';
export var getPaymentMovies = function getPaymentMovies() {
  return __awaiter(_this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", axios.get("/payment/movies").then(function (response) {
              return response.data;
            }).then(function (result) {
              if (result.success) {
                return result.data;
              } else {
                throw Error(result.message);
              }
            }).then(function (payload) {
              return {
                payload: payload
              };
            }).catch(function (error) {
              var message = error.message;

              if (error.response && error.response.status === 404) {
                return {
                  error: 404
                };
              }

              return {
                error: message
              };
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};